import ShowPreviewCard from "./ShowPreviewCard";
import { VenuePagesRow } from "@punchup/data";
import { useVenuePageShows } from "../../../hooks";

interface Props {
  venuePage: VenuePagesRow;
}

export default function VenueBannerCarouselSettingsDefault({
  venuePage,
}: Props) {
  const { shows, isLoading: isLoadingShows } = useVenuePageShows({
    venuePageId: venuePage.id,
    venueSlug: venuePage.slug,
  });

  return (
    <div className="flex flex-col gap-3">
      <h3 className="font-medium text-base text-primary-blue">
        Upcoming shows
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {isLoadingShows ? (
          <>
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="rounded-lg overflow-hidden bg-gray-200 aspect-[16/9] animate-pulse"
              />
            ))}
          </>
        ) : shows.length > 0 ? (
          shows
            .slice(0, 5)
            .map((show) => (
              <ShowPreviewCard
                key={show.id}
                show={show}
                venuePageId={venuePage.id}
              />
            ))
        ) : (
          <p className="col-span-full text-sm text-gray-500">
            No upcoming shows found
          </p>
        )}
      </div>
    </div>
  );
}
